import type { IntlShape } from 'react-intl';

import { defineMessages } from 'react-intl';

export interface HomeSuggestedQuestion {
  id: string;
  text: string;
}

export const MAX_SUGGESTED_QUESTIONS = 3;
export const MAX_SUGGESTED_QUESTION_LENGTH = 120;

const messages = defineMessages({
  autoRenew: {
    id: 'Home.suggestedQuestions.autoRenew',
    defaultMessage: 'Which contracts auto-renew?',
    description: 'Default Home suggested question: auto-renewing contracts',
  },
  expiring: {
    id: 'Home.suggestedQuestions.expiring',
    defaultMessage: 'Which contracts expire in the next 90 days?',
    description: 'Default Home suggested question: expiring contracts',
  },
  highestValue: {
    id: 'Home.suggestedQuestions.highestValue',
    defaultMessage: 'Which highest-value contracts renew this year?',
    description: 'Default Home suggested question: highest-value contracts',
  },
});

// The three curated, document-scoped starters shown until a person edits
// their own. Kept to documents only — Ask AI doesn't answer over requests yet.
export function getDefaultSuggestedQuestions(
  intl: IntlShape,
): HomeSuggestedQuestion[] {
  return [
    { id: 'expire-90d', text: intl.formatMessage(messages.expiring) },
    { id: 'auto-renew-notice', text: intl.formatMessage(messages.autoRenew) },
    {
      id: 'highest-value-renew',
      text: intl.formatMessage(messages.highestValue),
    },
  ];
}
